// extracted by mini-css-extract-plugin
export default {"transition":"styles-module__transition__src-labstep-web-components-ExperimentWorkflow-Action-UpdateEntityState-ModalWizard-StepOverview-_LgXWY"};